import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { SentryService } from './sentry.service';
import { ConfigService } from './config.service';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Env } from '../dto/enum/env.enum';
import loadjs from 'loadjs';

interface YaContextCbWindow extends Window {
  yaContextCb: unknown[];
}

declare let window: YaContextCbWindow;

@Injectable({
  providedIn: 'root',
})
export class YaBannerService {
  private readonly sentryService: SentryService = inject(SentryService);
  private readonly configService: ConfigService = inject(ConfigService);
  private readonly document: Document = inject<Document>(DOCUMENT);
  private readonly platformId: object = inject(PLATFORM_ID);

  public constructor() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    window.yaContextCb = window.yaContextCb || [];

    if (Env.PROD !== this.configService.env) {
      return;
    }

    this.loadYaBannerScript();
  }

  public push(blockId: string, renderTo: string, type: string): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    window.yaContextCb.push((): void => {
      // @ts-ignore
      Ya.Context.AdvManager.render({ blockId, renderTo, type });
    });
  }

  private loadYaBannerScript(): void {
    if (this.document.getElementById('ya-banner')) {
      return;
    }

    loadjs('https://yandex.ru/ads/system/context.js', {
      async: true,
      numRetries: this.configService.retryCount,
      error: (): void => {
        console.error('An error occurred during loading Ya Banner script');
        this.sentryService.captureException({
          error: 'An error occurred during loading Ya Banner script',
          severityLevel: 'warning',
          transactionName: 'LOAD_YA_BANNER_SCRIPT_ERROR',
        });
      },
      before: (path: string, scriptEl: HTMLElement): boolean => {
        const htmlElement: HTMLElement | null =
          this.document.getElementById('ya-banner');
        if (htmlElement) {
          htmlElement.parentElement?.removeChild(htmlElement);
        }
        scriptEl.id = 'ya-banner';
        return true;
      },
    });
  }
}
